/**
 * "2 critiques" as a toggle: open it and the critiques are right there —
 * title, the first lines, severity, who said it — each a click from its drawer.
 */
import { useState } from 'react';
import type { BoardroomCritiqueRow, BoardroomPersona } from '../../../types';

export default function Critiques({
  rows,
  onOpen,
  personas,
  className = '',
}: {
  rows: BoardroomCritiqueRow[];
  onOpen: (itemId: number) => void;
  personas?: Map<number, BoardroomPersona>;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  if (rows.length === 0) return null;
  return (
    <span className={`inline ${className}`}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        className="text-[11px] text-amber-700 dark:text-amber-300 hover:underline"
        data-testid="critiques-toggle"
      >
        {rows.length} critique{rows.length === 1 ? '' : 's'} {open ? '▾' : '▸'}
      </button>
      {open && (
        <ul className="mt-1 flex flex-col gap-1 border-l-2 border-amber-300 dark:border-amber-700 pl-2" data-testid="critiques">
          {rows.map(c => (
            <li key={c.id} className="text-xs">
              <button type="button" onClick={() => onOpen(c.id)} className="text-left text-gray-800 dark:text-gray-200 hover:underline">
                {c.title}
              </button>
              {c.severity !== null && <span className="ml-1 text-[11px] text-amber-700 dark:text-amber-300">severity {c.severity}/5</span>}
              {c.by !== null && personas && <span className="ml-1 text-[11px] text-gray-400">· {personas.get(c.by)?.name ?? `persona #${c.by}`}</span>}
              {c.body && <p className="text-gray-600 dark:text-gray-300">{c.body}</p>}
            </li>
          ))}
        </ul>
      )}
    </span>
  );
}
